import { a as GITHUB_API_KEY, G as GITHUB_USER } from "./private.js";
import { Octokit } from "@octokit/rest";
import { d as delay } from "./utils2.js";
const octokit = new Octokit({
  auth: GITHUB_API_KEY
});
const getWorkflowJob = async (workflowId) => {
  const jobs = await octokit.rest.actions.listJobsForWorkflowRun({
    owner: GITHUB_USER,
    repo: "glimmr",
    run_id: workflowId,
    filter: "latest"
  });
  return jobs.data.jobs[0];
};
const waitUntilWorkflowInProgress = async (branch, waitDuration = 5e3) => {
  const workflows = await octokit.rest.actions.listWorkflowRuns({
    owner: GITHUB_USER,
    repo: "glimmr",
    branch,
    workflow_id: "main.yml",
    status: "in_progress"
  });
  const workflow = workflows.data.workflow_runs[0];
  if (workflow) {
    return workflow;
  }
  await delay(waitDuration);
  return waitUntilWorkflowInProgress(branch, waitDuration);
};
const pollWorkflowJob = async (jobId, onUpdate, waitDuration = 5e3) => {
  const job = await octokit.rest.actions.getJobForWorkflowRun({
    owner: GITHUB_USER,
    repo: "glimmr",
    job_id: jobId
  });
  onUpdate(job.data);
  if (job.data.status === "completed") {
    return job.data;
  }
  await delay(waitDuration);
  return pollWorkflowJob(jobId, onUpdate, waitDuration);
};
const triggerWorkflow = (branch, access) => {
  return octokit.rest.actions.createWorkflowDispatch({
    workflow_id: "main.yml",
    repo: "glimmr",
    owner: GITHUB_USER,
    ref: branch,
    inputs: {
      access
    }
  });
};
export {
  getWorkflowJob as g,
  octokit as o,
  pollWorkflowJob as p,
  triggerWorkflow as t,
  waitUntilWorkflowInProgress as w
};
